// extracted by mini-css-extract-plugin
export default {"slideshow":"WebBackgroundSlideshow_slideshow__2Vm-L","track":"WebBackgroundSlideshow_track__j-nWs","slide":"WebBackgroundSlideshow_slide__N6sbQ"};